import { createApp } from "vue";
import App from "./App.vue";
import router from "@/routes/index.js";
import store from "@/store/index.js";
import i18n from "@/i18n/index.js";
import VueClipboard from "vue-clipboard2";
import VueDOMPurifyHTML from 'vue-dompurify-html';
// import { useI18n } from "vue-i18n";
// const {t} = useI18n();
// app.config.globalProperties.t = t
let app = createApp(App);
app.use(VueClipboard).use(i18n).use(store).use(router).use(VueDOMPurifyHTML).mount("#app");
